// extracted by mini-css-extract-plugin
module.exports = {"app":"app___2iKXm"};